import { InputLabel, MenuItem, FormControl, Select } from '@material-ui/core';

const menuProps = {
    anchorOrigin: { vertical: "bottom", horizontal: "left" },
    transformOrigin: { vertical: "top", horizontal: "left" },
    getContentAnchorEl: null
};

const FilterSelect = ({ id, label, value, onChange, options = [], disabled = false, renderValue = undefined, title = undefined }) => (
    <FormControl variant="outlined" fullWidth>
        <InputLabel id={`${id}-label`}>{label}</InputLabel>
        <Select
            value={value || ''}
            onChange={onChange}
            label={label}
            labelId={`${id}-label`}
            id={`${id}-select`}
            MenuProps={menuProps}
            disabled={disabled}
            title={title}
            {...(renderValue ? { renderValue } : {})}
        >
            {options?.map((item, index) => (
                <MenuItem key={index} value={item.value}>{item.label}</MenuItem>
            ))}
        </Select>
    </FormControl>
);

export default FilterSelect;